module.exports = __webpack_public_path__ + "static/media/sociana.4d5908b1.png";